import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';

//* Helpers
import { getPageNumbers } from './functions';

//* Components
import Icon from '@/components/common/Icon';

//* Style
import PaginationStyle from './style';

const Pagination = ({ total, pageSize, onCategoryChange, pageNumbersToShow, prevIconName = 'arrow-big', nextIconName = 'arrow-big' }) => {
	const searchParams = useSearchParams();

	const currentPage = useMemo(() => Number(searchParams.get('page')) || 1, [searchParams]);

	const isLastPage = currentPage * pageSize >= total;
	const pageNumbers = getPageNumbers({ currentPage, pageSize, total, pageNumbersToShow });

	return (
		<PaginationStyle className='pagination'>
			<div className={'pagination__list'}>
				<div
					className={`h4 prev-btn  ${currentPage === 1 ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage - 1)}>
					<Icon
						className={'h4'}
						name={prevIconName}
					/>
				</div>

				{pageNumbers.map((pageNumber, index) => {
					return pageNumber === '...' ? (
						<span
							className='dots h4'
							key={index}
							label='ellipsis'>
							&hellip;
						</span>
					) : (
						<div
							key={index}
							onClick={() => onCategoryChange('page', pageNumber)}
							className={`pagination-item font-futura-regular h4 ${pageNumber === currentPage ? 'active' : ''}`}>
							{pageNumber}
						</div>
					);
				})}

				<div
					className={`p p3 next-btn  ${isLastPage ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage + 1)}>
					<Icon
						className={'h4'}
						name={nextIconName}
					/>
				</div>
			</div>
		</PaginationStyle>
	);
};

export default Pagination;
